export default __webpack_public_path__ + "static/media/StatusPage.c8cee330.svg";